import ScrollToTop from "./ScrollToTop";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import Header from "./Header";
import MobileNav from "./MobileNav";
import Footer from "./Footer";
import { timelineItems } from "../features/timeline/data/timelineItems";
import { useBodyScrollLock } from "../hooks/useBodyScrollLock";

export default function MainLayout() {
  const [menuOpen, setMenuOpen] = useState(false);
  useBodyScrollLock(menuOpen);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

const activeTopTab = useMemo(() => {
  if (location.pathname === "/") return "Strona główna";
  if (location.pathname.startsWith("/kontakt")) return "Kontakt";
  if (location.pathname.startsWith("/wydarzenia")) return "Wydarzenia";
  if (location.pathname.startsWith("/sciezka-czasu")) return "Ścieżka czasu";
  if (
    location.pathname.startsWith("/w-budowie") ||
    location.pathname.startsWith("/kerin-historia-i-misja")
  ) {
    return "Kerin – Historia i Misja";
  }
  return "";
}, [location.pathname]);

 const topTabs = ["Strona główna", "Ścieżka czasu", "Kerin – Historia i Misja", "Kontakt"];

 const onNavigate = (tabName) => {
  if (tabName === "Strona główna") return navigate("/");
  if (tabName === "Ścieżka czasu") return navigate("/sciezka-czasu");
  if (tabName === "Kerin – Historia i Misja") return navigate("/kerin-historia-i-misja");
  if (tabName === "Wydarzenia") return navigate("/wydarzenia");
  return navigate("/kontakt");
};

  const onTimelineNavigate = (slug) => navigate(`/sciezka-czasu/${slug}`);

return (
  <div className="appShell">
    <ScrollToTop />

    <Header
      topTabs={topTabs}
      activeTopTab={activeTopTab}
      onNavigate={onNavigate}
      timelineItems={timelineItems}
      onTimelineNavigate={onTimelineNavigate}
      onOpenMenu={() => setMenuOpen(true)}
    />

    <MobileNav
      open={menuOpen}
      topTabs={topTabs}
      activeTopTab={activeTopTab}
      timelineItems={timelineItems}
      onClose={() => setMenuOpen(false)}
      onNavigate={onNavigate}
      onTimelineNavigate={onTimelineNavigate}
    />

    <main className="pageMain">
      <Outlet />
    </main>

    <Footer />
  </div>
);
}